const iconStyle = {
  width: 34,
  height: 34,
  stroke: 'currentColor',
  strokeWidth: 2,
  fill: 'none',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const buildIcon = (svg) => <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#0f172a' }}>{svg}</span>;

export const INDUSTRIES_DIRECTORY = [
  {
    num: '01',
    title: 'Healthcare',
    to: '/industries/healthcare',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M3 9.5V7.2A2.2 2.2 0 0 1 5.2 5h13.6A2.2 2.2 0 0 1 21 7.2v2.3" />
        <path d="M5 9.5h14v8.3A2.2 2.2 0 0 1 16.8 20H7.2A2.2 2.2 0 0 1 5 17.8V9.5Z" />
        <path d="M9 9.5V7.2M15 9.5V7.2M9 12.5h6M12 9.5v6" />
      </svg>
    ),
    desc: 'EMR/EHR systems, telemedicine apps, hospital management platforms, and patient portals built for compliance and efficiency.',
    tag: 'Healthcare / Compliance',
  },
  {
    num: '02',
    title: 'Education & E-Learning',
    to: '/industries/education',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M3 9.5 12 5l9 4.5-9 4.5L3 9.5Z" />
        <path d="M7 11.4v4.6c0 1.1 2.2 2.5 5 2.5s5-1.4 5-2.5v-4.6" />
        <path d="M21 9.5v7" />
      </svg>
    ),
    desc: 'LMS platforms, online exam systems, student management, virtual classrooms, and corporate training solutions.',
    tag: 'EdTech / Learning',
  },
  {
    num: '03',
    title: 'Real Estate & Construction',
    to: '/industries/real-estate',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M4 20V8.5L12 4l8 4.5V20" />
        <path d="M9 20v-5h6v5" />
        <path d="M8 9.5h8M8 12h8" />
      </svg>
    ),
    desc: 'Property listing portals, project management tools, CRM for realtors, and digital contract management systems.',
    tag: 'Property / Operations',
  },
  {
    num: '04',
    title: 'Retail & E-commerce',
    to: '/industries/retail',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M4 8.5h16l-1 11H5l-1-11Z" />
        <path d="M8 8.5V7A4 4 0 0 1 12 3a4 4 0 0 1 4 4.5v1" />
        <path d="M12 12v4M9.5 14h5" />
      </svg>
    ),
    desc: 'Custom online stores, inventory sync, POS systems, multi-vendor marketplaces, and omnichannel retail platforms.',
    tag: 'Retail / Commerce',
  },
  {
    num: '05',
    title: 'Manufacturing',
    to: '/industries/manufacturing',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M4 18V9.5L8 7V5h12v13H4Z" />
        <path d="M8 18v-5h8v5M10 9.5h4" />
        <path d="M16 9.5h4" />
      </svg>
    ),
    desc: 'Production planning, ERP systems, quality control, supply chain visibility, and IoT-enabled monitoring dashboards.',
    tag: 'Manufacturing / Industry 4.0',
  },
  {
    num: '06',
    title: 'Logistics & Supply',
    to: '/industries/logistics',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M2.5 8.5h12v8h-12zM14.5 10.5h3.3l2.7 2.8v4.2h-6v-7Z" />
        <circle cx="7.5" cy="17" r="1.8" />
        <circle cx="17.5" cy="17" r="1.8" />
      </svg>
    ),
    desc: 'Fleet tracking, route optimization, warehouse management, real-time shipment visibility, and delivery automation.',
    tag: 'Logistics / Mobility',
  },
  {
    num: '07',
    title: 'Finance & Banking',
    to: '/industries/fintech',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M3 10.5 12 5l9 5.5-9 5.5-9-5.5Z" />
        <path d="M7 13.2v3.2c0 1.3 2.2 2.6 5 2.6s5-1.3 5-2.6v-3.2" />
        <path d="M12 12v7" />
      </svg>
    ),
    desc: 'Mobile banking, loan origination, payment gateways, KYC/AML compliance tools, and investment platforms.',
    tag: 'Finance / Security',
  },
  {
    num: '08',
    title: 'Travel & Hospitality',
    to: '/industries/travel',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M2.5 14.5 7 12l4.5-4.5 5.2 2.3c1.6.7 2.8 2.4 2.8 4.2v.5H2.5z" />
        <path d="M7 12v5M12 7.5v9.5M18 10.5v6" />
      </svg>
    ),
    desc: 'Hotel PMS, online booking engines, channel managers, guest CRM, loyalty programmes, and digital concierge apps.',
    tag: 'Travel / Guest Experience',
  },
  {
    num: '09',
    title: 'Food & Restaurant',
    to: '/industries/food',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M7 3v7M10 3v7M13 3v7M16 3v7" />
        <path d="M5 10h14v2.5A4.5 4.5 0 0 1 14.5 17H9.5A4.5 4.5 0 0 1 5 12.5V10Z" />
        <path d="M18 3v8" />
      </svg>
    ),
    desc: 'Online ordering, POS systems, kitchen display software, delivery tracking, inventory control, and loyalty apps.',
    tag: 'Food / Operations',
  },
  {
    num: '10',
    title: 'Automotive',
    to: '/industries/automotive',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <path d="M5 15.5V9.8l2.2-3h9.6l2.2 3v5.7" />
        <path d="M3.5 15.5h17" />
        <circle cx="7.5" cy="16.5" r="1.8" />
        <circle cx="16.5" cy="16.5" r="1.8" />
      </svg>
    ),
    desc: 'Dealer management, service centre software, vehicle tracking, parts inventory, and customer service portals.',
    tag: 'Automotive / Service',
  },
  {
    num: '11',
    title: 'Information Technology',
    to: '/industries/it',
    accent: '#0f172a',
    icon: buildIcon(
      <svg viewBox="0 0 24 24" aria-hidden="true" style={iconStyle}>
        <rect x="3" y="5" width="14" height="10" rx="1.8" />
        <path d="M8 19h6M12 15v4" />
        <path d="M21 8v9" />
      </svg>
    ),
    desc: 'SaaS product development, IT service management, helpdesk platforms, DevOps tools, and API integrations.',
    tag: 'IT / Platforms',
  }
];
